// :cow: Cosmose CONFIDENTIAL :iso:
export const environment = {
  production: true,
};
